import { render, staticRenderFns } from "./BreakdownSelector.vue?vue&type=template&id=15ff07b7&"
import script from "./BreakdownSelector.vue?vue&type=script&lang=js&"
export * from "./BreakdownSelector.vue?vue&type=script&lang=js&"
import style0 from "./BreakdownSelector.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports